import { render, staticRenderFns } from "./zhengwuzhiyuan.vue?vue&type=template&id=283b8236&scoped=true&"
import script from "./zhengwuzhiyuan.vue?vue&type=script&lang=js&"
export * from "./zhengwuzhiyuan.vue?vue&type=script&lang=js&"
import style0 from "./zhengwuzhiyuan.vue?vue&type=style&index=0&id=283b8236&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283b8236",
  null
  
)

export default component.exports